import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('fatturatoHotels');
export const actions = helper.createActions('fatturatoHotels', actionTypes);